import { AppConfig, ApplicationType, Environment, ROUTES } from '@maia/config';
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';

export function buildAuthConfigs(environment: Environment): OpenIdConfiguration[] {
  return (Object.keys(environment.apps) as ApplicationType[]).map(id => buildAuthConfig(id, environment.apps[id]));
}

function buildAuthConfig(id: ApplicationType, app: AppConfig): OpenIdConfiguration {
  return {
    configId: id,
    authority: app.discoveryUrl,
    clientId: app.clientId,
    redirectUrl: app.redirectUrl,
    postLogoutRedirectUri: window.location.origin,
    scope: app.scopes,
    responseType: 'code',
    forbiddenRoute: ROUTES.forbidden,
    unauthorizedRoute: ROUTES.unauthorized,
    ignoreNonceAfterRefresh: true,
    historyCleanupOff: true,
    useRefreshToken: true,
    autoUserInfo: false,
    silentRenew: true,
    secureRoutes: [app.apiUrl],
    logLevel: LogLevel.None,
  };
}
